'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.apiAuthLogout = exports.api_auth_logout_failure = exports.api_auth_logout_success = exports.api_auth_logout_request = exports.API_AUTH_LOGOUT_FAILURE = exports.API_AUTH_LOGOUT_SUCCESS = exports.API_AUTH_LOGOUT_REQUEST = undefined;

var _index = require('axios/index');

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var API_AUTH_LOGOUT_REQUEST = exports.API_AUTH_LOGOUT_REQUEST = 'API_AUTH_LOGOUT_REQUEST';
var API_AUTH_LOGOUT_SUCCESS = exports.API_AUTH_LOGOUT_SUCCESS = 'API_AUTH_LOGOUT_SUCCESS';
var API_AUTH_LOGOUT_FAILURE = exports.API_AUTH_LOGOUT_FAILURE = 'API_AUTH_LOGOUT_FAILURE';

var api_auth_logout_request = exports.api_auth_logout_request = function api_auth_logout_request() {
	return {
		type: API_AUTH_LOGOUT_REQUEST,
		payload: {
			loading: true
		}
	};
};

var api_auth_logout_success = exports.api_auth_logout_success = function api_auth_logout_success(data) {
	return {
		type: API_AUTH_LOGOUT_SUCCESS,
		payload: {
			loading: false,
			data: data,
			error: null
		}
	};
};

var api_auth_logout_failure = exports.api_auth_logout_failure = function api_auth_logout_failure(error) {
	return {
		type: API_AUTH_LOGOUT_FAILURE,
		payload: {
			loading: false,
			error: error
		}
	};
};

/*
	AuthManagerAPI.apiAuthLogout
*/
var apiAuthLogout = exports.apiAuthLogout = function apiAuthLogout(options) {
	return function (dispatch, getState) {
		return new Promise(function (resolve, reject) {
			dispatch(api_auth_logout_request());
			(0, _index2.default)({
				method: 'get',
				url: '/api/auth/logout'
			}).then(function (response) {
				if (response.data.SUCCESSFUL) {
					dispatch(api_auth_logout_success(response.data.DATA));
					resolve();
				} else {
					dispatch(api_auth_logout_failure(response.data));
					resolve();
				}
			}, function (err) {
				console.log(err);
				reject();
			});
		});
	};
};